export const MEDEWERKERS_OP_STATION_VOS_QUERY_KEY = "vossen";
export const MEDEWERKERS_OP_STATION_STATIONS_QUERY_KEY = "vos-stations";
export const MEDEWERKERS_OP_STATION_AANVRAGEN_QUERY_KEY = "vos-aanvraag";
export const MEDEWERKERS_OP_STATION_QUERY_KEY = "medewerkers-op-station";
export const VOS_OPROEPEN_QUERY_KEY = "dossier-vos-oproepen"; // for debug admin endpoint
